module.exports = __webpack_public_path__ + "img/icon_2.34ef1a13.png";